import React from "react";
import "./BannerMessage.scss";
import Link from "components/_ui/Link/Link";
import MaxWidth from "components/_ui/MaxWidth/MaxWidth";

const BannerMessage = ({ github, reason }) => {
    return (
        <MaxWidth className={`BannerMessage BannerMessage__reason--${reason}`} size="l">
            <h5 className="BannerMessage__message">Archived Project</h5>
            <div className="BannerMessage__actions">
                <Link doOpenInNewTab to={github} className="">
                    Repo
                </Link>
                <Link doOpenInNewTab to="https://marguerite.io/" className="site">
                    marguerite.io →
                </Link>
            </div>
        </MaxWidth>
    );
};

export default BannerMessage;
